import React, { useEffect } from 'react';
import { ArrowRight } from 'lucide-react';
import './SharedPages.css';

function AboutPage() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="page-wrapper">
      <div className="page-container">
        <div className="page-header">
          <h1 className="page-title">Notre Histoire</h1>
          <p className="page-subtitle">
            On a voulu reprendre le contrôle de notre pause du midi. Alors on a construit l'outil qui n'existait pas.
          </p>
        </div>

        <div className="page-content">
          <p>
            CrousRadar est né d'un constat hyper simple sur les campus universitaires : l'organisation du repas peut vite devenir chaotique lorsqu'on n'a aucune visibilité sur l'affluence avant d'arriver devant les portes du Resto U.
          </p>
          <p>
            On connaît tous le scénario : tu sors de cours à 12h15, tu marches jusqu'au RU, et làfile d'attente monumentale. 25 minutes debout, ton créneau de pause fond comme neige au soleil, et parfois tu finis par lâcher l'affaire pour un sandwich à 6 € d'à côté. Multiplié par cinq jours de cours, ça représente des heures perdues chaque semaine pour des milliers d'étudiants.
          </p>
          <p>
            Plutôt que de laisser le hasard dicter notre emploi du temps, on s'est dit qu'il fallait utiliser la plus grande force de nos campus : <strong>la solidarité étudiante</strong>. L'idée est évidentes'entraider pour consulter et partager en direct l'état des files d'attente. Si un étudiant qui sort du RU signale que c'est blindé, ceux qui n'ont pas encore bougé peuvent attendre 15 minutes et arriver pile quand ça se vide.
          </p>

          <h2>Du projet de potes à l'app nationale</h2>
          <p>
            Au départ, CrousRadar c'était un groupe WhatsApp. Sérieusement. Quelques potes qui s'envoyaient "c'est vide" ou "évitez Dolet" avant de partir manger. Ça marchait tellement bien entre nous qu'on s'est demandé : et si tout le campus pouvait en profiter ?
          </p>
          <p>
            Quelques nuits de code plus tard, un premier prototype tournait. Pas joli, pas stable, mais fonctionnel. Les retours ont été immédiats : en une semaine, la moitié de notre promo l'avait adopté. Puis les amis d'amis. Puis d'autres facs.
          </p>
          <p>
            Aujourd'hui, CrousRadar c'est plus de <strong>5 000 étudiants actifs</strong> sur des dizaines de campus en France. Une vraie communauté qui s'entraide chaque jour pour optimiser la pause déj'. Et on n'a pas mis un centime en pubtout s'est fait par le bouche-à-oreille, parce que quand un truc est vraiment utile, les gens en parlent.
          </p>

          <h2>Ce qu'on défend</h2>
          <p>
            On est une solution <strong>100% française</strong>, construite par des étudiants pour des étudiants. Pas de levée de fonds, pas d'actionnaires à satisfaire, pas de pression pour monétiser vos données. On a fait le choix de l'indépendance totale parce qu'on estime que c'est la seule manière de rester alignés avec les intérêts de notre communauté.
          </p>
          <p>
            Concrètement, ça veut dire : données hébergées en France, aucun tracking publicitaire, aucune revente d'informations personnelles. L'app est gratuite et le restera. Toujours.
          </p>

          <h2>Notre Vision</h2>
          <p>
            Au-delà du gain de temps individuel, on a vite réalisé l'impact collectif de CrousRadar. En fluidifiant les flux vers les différents RU, on aide les équipes en cuisine à mieux anticiper la demande, et on contribue concrètement à réduire le gaspillage alimentaire. C'est du gagnant-gagnant.
          </p>
          <p>
            Notre objectif : que chaque campus de France soit couvert. Que l'information sur l'affluence devienne aussi naturelle que checker la météo avant de sortir. On y va étape par étapeAndroid arrive bientôt, et chaque jour de nouveaux restaurants sont ajoutés par la communauté.
          </p>

          <div className="brutal-info-grid">
            <div className="brutal-info-card">
              <h3>Transparence 100%</h3>
              <p>Une donnée participative, libre et toujours gratuite. Pas de mauvaise surprise, pas de modèle caché.</p>
            </div>
            <div className="brutal-info-card">
              <h3>Impact Direct</h3>
              <p>Chaque signalement aide immédiatement les étudiants de ton campus. Toi aujourd'hui, les autres demain.</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AboutPage;
